import { request } from '@/shared/api/request'

export const getAll = () => {
	return request({
		url: 'notification/get/notifs/all',
		method: 'GET',
	})
}
